import { useState } from "react";
import { useIntl } from "react-intl";
import classNames from "classnames";
import { LabelKeyValueItem } from "@/model";
import SearchBar from "@/component/input/Searchbar";
import { DropdownGroup, DropdownButton, DropdownItem, DropdownItems } from "@/component/input";


interface TypeSearchbarProps {
    className?: string;
    searchTypes: LabelKeyValueItem[];
    placeholder?: string;
    onSearch: (keyword: string, option: LabelKeyValueItem) => void;
}

const TypeSearchbar: React.FC<TypeSearchbarProps> = (props) => {
    const {
        searchTypes,
        className: propsClassName,
        placeholder,
        onSearch
    } = props;

    const intl = useIntl();

    const [selectedType, setSelectedType] = useState<LabelKeyValueItem>(searchTypes[0]);

    return (
        <div className={classNames("flex items-center", propsClassName)}>
            <DropdownGroup width={128} className="h-[41px]">
                <DropdownButton variant="secondary"
                                className="rounded-r-none h-full"
                >
                    {intl.formatMessage({ id: selectedType.labelKey })}
                </DropdownButton>
                <DropdownItems variant="secondary"
                               className="rounded-tr-none"
                >
                    {searchTypes.map((searchType) => (
                        <DropdownItem key={searchType.value}
                                      onClick={() => setSelectedType(searchType)}
                        >
                            {intl.formatMessage({ id: searchType.labelKey })}
                        </DropdownItem>
                    ))}
                </DropdownItems>
            </DropdownGroup>
            <SearchBar className="-ml-px rounded-l-none"
                       placeholder={placeholder ?? intl.formatMessage({ id: "i00018" })} 
                       onSearch={keyword => onSearch(keyword, selectedType)}
            />
        </div>
    );
};

export default TypeSearchbar;
